import React from 'react';
import { twMerge } from 'tailwind-merge';

type BetaFlagProps = {
  size?: 'small' | 'medium' | 'large';
  className?: string;
};

const BetaFlag: React.FC<BetaFlagProps> = ({ size = 'medium', className }) => {
  const sizeClasses = {
    small: 'text-xs px-1 py-0.5',
    medium: 'text-sm px-1.5 py-0.5',
    large: 'text-base px-2 py-1',
  };

  return (
    <div
      className={twMerge(
        'inline-flex items-center justify-center bg-teal-050 text-teal-700 font-bold rounded-md',
        sizeClasses[size],
        className
      )}
    >
      Beta
    </div>
  );
};

export default BetaFlag;
